import React from "react";

import "./App.css";
import "./Sidebar.css";

function Sidebaro(props) {
  return (
    <div className={"sidebaroption"}>
      {/* <props.icon /> */}
      <props.icon  className= "abc"/>
      <h2>{props.text}</h2>
    </div>
  );
}

export default Sidebaro;
